export enum StateEnum {
  LOADING,
  TO_DO,
  IN_PROGRESS,
  ON_HOLD,
  DISCARDED,
  COMPLETED,
  REVIEW,
}
